/**
 * GoHighLevel embed mode.
 *
 * The app is opened inside a GHL custom menu link's iframe. Being framed is the
 * only signal needed — the server has already recorded which sub-account the
 * frame belongs to from the `location_id` merge field (see api/embed.go), so the
 * client only has to adapt its chrome and its signed-out path.
 *
 * Deliberately not a query parameter or a stored flag: those survive navigation
 * and get stale, whereas "am I in a frame" is always accurate for the document
 * asking the question.
 */
export function isEmbedded(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    // Touching window.top across origins can throw. Throwing is itself proof
    // there is a cross-origin parent, so this is the framed case too.
    return true;
  }
}
